import { useNavigate, Link, NavLink } from "react-router-dom";

import { BLOCKS, OLD_LK_URL } from '../blocks';


function MenuItem({title, to, end}) {
  return (
    <li className="nav-link">
      <NavLink className="lk-link" to={to} end={end}>{title}</NavLink>
    </li>
  );
}


function SideBar({years, selectedYear, currentYear, setSelectedYear, activeBlock}) {
 
  const navigate = useNavigate();
  const isPastYear = selectedYear < currentYear;

  // Страницы внутри блока относятся к выбранному году, поэтому после смены года открываем стартовую страницу блока
  function setYear(year) {
    setSelectedYear(year);
    console.log(year);
    localStorage.setItem('selectedYear', year);
    navigate(activeBlock ? activeBlock.path : "/");
    navigate(0);
  }

  let rows=[]
  for (let i in years) {
    rows.push(
      <button key={years[i]} className="lk-button dropdown-item" type="button" onClick={() => setYear(years[i])}>
        {years[i]}
      </button>
    )
  }

  let menuItems = [];
  if (activeBlock) {
    menuItems = activeBlock.menu
      .filter(item => !(item.currentYearOnly && isPastYear))
      .map(item =>
        <MenuItem key={item.to} title={item.title} to={item.to} end={item.to === activeBlock.path} />
      );
  } else {
    menuItems = Object.values(BLOCKS).map(block =>
      <MenuItem key={block.id} title={block.title} to={block.path} />
    );
  }

  return(
    <>
      <div className="left-panel h-100 pt-4">
        <div className="px-4 ms-2 me-3">
            <nav className="navbar navbar-expand-lg">
              <button className="lk-year-button dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                <p>год договора</p>
                {selectedYear}
              </button>
              <ul className="dropdown-menu lk-year-dropdown">
                {rows}
              </ul>
            </nav>

        </div>
        <nav className="nav flex-column p-3">
          {activeBlock &&
            <>
              <li className="nav-link pt-0">
                <Link className="lk-link" to="/"><small><i className="bi bi-arrow-left me-1"></i>На главную</small></Link>
              </li>
              <li className="lk-sidebar-block-title me-3 mt-4 mb-3">{activeBlock.title}</li>
            </>
          }
          {menuItems}

        </nav>
        <div className='position-absolute bottom-0 start-50 translate-middle-x mb-3'>
               
          <p className="text-center">МСИ «ФСВОК» {selectedYear}</p>
        </div>
      </div>  
    </>
  );
}

export default SideBar
